module.exports = __webpack_public_path__ + "static/media/bg-login-rf-2.bc69dc27.jpg";